import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faUsers, faBox, faFileContract, faUserTie,
    faWarehouse, faUser, faFilePdf,
    faLaptopCode, faTags, faScrewdriverWrench,faClipboardCheck
} from '@fortawesome/free-solid-svg-icons';
import { motion } from 'framer-motion';
import logo from '../assets/Logo-HM.png';
import img from '../assets/User.png';
import jwt_decode from 'jwt-decode';
import Swal from "sweetalert2";
import { faFileInvoice } from '@fortawesome/free-solid-svg-icons';


function Index() {

    const [search, setSearch] = useState('');
    const [user, setUser] = useState(null);
    const navigate = useNavigate();

    //  LEER TOKEN AL CARGAR Y CUANDO CAMBIE
    useEffect(() => {
        const loadUser = () => {
            const token = localStorage.getItem('access_token');
            if (token) {
                try {
                    setUser(jwt_decode(token));
                } catch {
                    setUser(null);
                }
            } else {
                setUser(null);
            }
        };

        loadUser();

        //  ESCUCHA CUANDO SE ACTUALIZA EL TOKEN
        window.addEventListener('storage', loadUser);

        return () => {
            window.removeEventListener('storage', loadUser);
        };
    }, []);

    //  IMAGEN REACTIVA
    const userImage = user?.imagen
        ? user.imagen.startsWith('http')
            ? user.imagen
            : `https://api.hmsaa.com.mx:5001/uploads/${user.imagen}`
        : img;

    const isAdmin = user?.es_admin || false;

    // ---------------------------------------------------
    // NORMALIZAR TAG
    // ---------------------------------------------------
    const normalizarTag = (txt) =>
        txt
            .toUpperCase()
            .trim()
            .replace(/['.\s]/g, "-")
            .replace(/-{2,}/g, "-");

    // ---------------------------------------------------
    // BUSCADOR INTELIGENTE DE TAGS
    // ---------------------------------------------------
    const handleSearch = async (value) => {
        setSearch(value);

        const tag = normalizarTag(value);
        const API = "https://api.hmsaa.com.mx:5001/api";
        const pattern = /^[A-Z]{1,4}-\d{3}-\d{3}$/;

        if (!pattern.test(tag)) return;

        try {
            const res = await fetch(`${API}/tags/buscar/${tag}`);
            const data = await res.json();

            if (!data.found) {
                const crear = await Swal.fire({
                    title: "Tag no encontrado",
                    html: `¿Deseas registrar un <b>nuevo activo</b> con el tag <b>${tag}</b>?`,
                    icon: "question",
                    showCancelButton: true,
                    confirmButtonText: "Registrar",
                });

                if (crear.isConfirmed) {
                    navigate("/productos", { state: { autoOpenCreate: true, preTag: tag } });
                }
                return;
            }

            if (!data.asignado) {
                const asignar = await Swal.fire({
                    title: "Tag sin asignar",
                    html: `El tag <b>${tag}</b> existe pero no está asignado a ningún activo.`,
                    icon: "info",
                    showCancelButton: true,
                    confirmButtonText: "Asignar",
                });

                if (asignar.isConfirmed) {
                    navigate("/productos", {
                        state: { autoOpenTags: true, tagId: data.tag.id_tag }
                    });
                }
                return;
            }

            navigate("/productos", { state: { filtroInicial: tag } });

        } catch (e) {
            console.error(e);
            Swal.fire("Error", "No se pudo conectar al servidor", "error");
        }
    };

    // ---------------------------------------------------
    // TARJETAS DEL MENÚ
    // ---------------------------------------------------
    const tables = [
        { name: 'Personal', route: '/personal', icon: faUsers, color: '#1976d2' },
        { name: 'Contratos', route: '/contratos', icon: faFileContract, color: '#6a1b9a' },
        { name: 'Proveedores', route: '/proveedores', icon: faUserTie, color: '#2e7d32' },
        { name: 'Tags', route: '/tags', icon: faTags, color: '#455a64' },
        { name: 'Facturas', route: '/facturas', icon: faFileInvoice, color: '#ef6c00' },
        { name: 'Activos', route: '/productos', icon: faBox, color: '#1565c0' },

        // SERVICIOS
        {
            name: 'Servicios',
            route: '/servicios',
            icon: faScrewdriverWrench,
            color: '#00838f'
        },

        { name: 'Almacenes', route: '/almacenes', icon: faWarehouse, color: '#5d4037' },
        { name: 'Software', route: '/software', icon: faLaptopCode, color: '#283593' },

        ...(isAdmin ? [{ name: 'Usuarios', route: '/usuarios', icon: faUser, color: '#37474f' }] : []),
        ...(isAdmin ? [{ name: 'Auditoria', route: '/auditoria', icon: faClipboardCheck, color: '#263238' }] : []),

        { name: 'Generar PDF', route: '/generar-pdf', icon: faFilePdf, color: '#c62828' },
    ];

    const filteredTables = tables.filter((table) =>
        table.name.toLowerCase().includes(search.toLowerCase())
    );

    const handleLogout = () => {
        localStorage.removeItem('access_token');
        navigate('/');
    };

    // ---------------------------------------------------
    // RENDER
    // ---------------------------------------------------
    return (
        <motion.div
            initial={{ scale: 0.5, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.8 }}
            style={{ fontFamily: 'Arial, sans-serif' }}
        >

            {/* NAVBAR */}
            <nav style={{
                backgroundColor: '#1976d2',
                color: '#fff',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '10px 20px',
            }}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <img src={logo} alt="Logo HM" style={{ height: '80px', marginRight: '10px' }} />
                    <h2>Sistemas de Administración de Activos</h2>
                </div>

                <button
                    onClick={handleLogout}
                    style={{
                        backgroundColor: '#f50057',
                        color: '#fff',
                        border: 'none',
                        padding: '10px 15px',
                        borderRadius: '5px',
                        cursor: 'pointer',
                    }}
                >
                    Cerrar Sesión
                </button>
            </nav>

            {/* FOTO USUARIO */}
            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
                <img
                    src={userImage}
                    alt="Usuario"
                    style={{
                        borderRadius: '50%',
                        border: '2px solid #1976d2',
                        padding: '5px',
                        height: '150px',
                        width: '150px',
                        objectFit: 'cover'
                    }}
                />
            </div>

            <h1 style={{ textAlign: 'center', marginTop: '20px' }}>Panel Principal</h1>

            {/* BUSCADOR */}
            <div style={{ display: 'flex', justifyContent: 'center', margin: '20px 0' }}>
                <input
                    type="text"
                    placeholder="Buscar menú"
                    value={search}
                    onChange={(e) => handleSearch(e.target.value)}
                    style={{
                        padding: '10px',
                        width: '60%',
                        fontSize: '16px',
                        border: '1px solid #ccc',
                        borderRadius: '5px'
                    }}
                />
            </div>

            {/* TARJETAS */}
            <div style={{
                display: 'flex',
                gap: '20px',
                flexWrap: 'wrap',
                justifyContent: 'center',
                padding: '20px'
            }}>
                {filteredTables.map((table) => (
                    <div
                        key={table.name}
                        onClick={() => navigate(table.route)}
                        style={{
                            border: '1px solid #ccc',
                            borderRadius: '10px',
                            padding: '20px',
                            textAlign: 'center',
                            cursor: 'pointer',
                            width: '200px',
                            backgroundColor: '#f9f9f9',
                        }}
                    >
                        <FontAwesomeIcon
                            icon={table.icon}
                            style={{
                                fontSize: '40px',
                                color: table.color
                            }}
                        />
                        <h3>{table.name}</h3>
                    </div>
                ))}
            </div>
        </motion.div>
    );
}

export default Index;
